export * from './FractionalOwnershipIcon'
